export const STORE_PYDANTIC_SCHEMA_GENERATOR = 'pydanticSchemaGeneratorUI';
export type STORE_PYDANTIC_SCHEMA_GENERATOR = typeof STORE_PYDANTIC_SCHEMA_GENERATOR;
